import Button from '@material-ui/core/Button';
import React from 'react';
import './BlueContainedButton.scss';

export const BlueContainedButton = ({ text, onClick, disabled }) => (
    <Button
        className={'blue-contained-button'}
        variant={'contained'}
        disabled={disabled}
        onClick={onClick}
    >
        {text}
    </Button>
);
